import { useLayoutEffect } from 'react'
import { useNavigate } from 'react-router'
import Loader from '../core/loader/Loader'

type DonePayload = {
    eventDetails?: {
        error?: { error_message?: string } | string
        id?: { unicity?: string }
    }
}

/**
 * 3DS return target. After the WorldPay ACS challenge completes, the bank redirects the
 * challenge iframe to this route with a `tppPayload` query param. Running inside the iframe,
 * we parse the result and postMessage it to the parent window, which closes the challenge
 * modal and finalises the order (see WorldPay3DS WP_3DS_SUCCESS / WP_3DS_FAILED handlers).
 * If the ACS did a top-level redirect instead (no iframe), we navigate to the result directly.
 */
const Done = () => {
    const navigate = useNavigate()

    useLayoutEffect(() => {
        const qs = new URLSearchParams(window.location.search)
        const tppPayload = qs.get('tppPayload')
        const paymentId = qs.get('payment_id') || qs.get('paymentId') || ''
        const isInIframe = window.self !== window.top

        let orderId = ''
        let errorMessage = ''

        if (tppPayload) {
            try {
                const payload = JSON.parse(tppPayload) as DonePayload
                orderId = payload?.eventDetails?.id?.unicity || ''
                const err = payload?.eventDetails?.error
                errorMessage = (typeof err === 'object' ? err?.error_message : err) || ''
            } catch {
                errorMessage = 'something_went_wrong_with_payment'
            }
        }

        const success = Boolean(orderId)

        if (isInIframe) {
            window.parent.postMessage(
                {
                    type: success ? 'WP_3DS_SUCCESS' : 'WP_3DS_FAILED',
                    payment_id: paymentId,
                    order_id: orderId,
                    error_message: errorMessage
                },
                '*'
            )
            return
        }

        // Full-page (non-iframe) fallback — e.g. the ACS performed a top-level redirect.
        if (success) navigate(`/payment-response/success?paymentId=${paymentId}`, { replace: true })
        else navigate('/payment', { replace: true })
    }, [navigate])

    return <Loader />
}

export default Done
